<template>
  <div class="bottle-log">
    <list :items="actionsReverse">
      <template v-slot:header>
        <div class="row">
          <div class="col-12">
            <h5>Action log</h5>
          </div>
          <div class="col-4 col-lg-3">Datum</div>
          <div class="col-8">Aktion</div>
        </div>
      </template>
      <template v-slot:itemTemplate="{item}">

        <div class="row align-items-center py-2">
          <div class="col-4 col-lg-3">
            <div class="row">
              <div class="col" style="max-width: 10em">
                {{ dateWithFormat(item.date, "DD.MM.YYYY") }}
              </div>
              <div class="col pl-lg-0">
                {{ dateWithFormat(item.date, "HH:mm") }}
              </div>
            </div>

          </div>
          <div class="col-8 col-lg-9">
            <!--						<pre>{{item}}</pre>-->
            <template v-if="!item">
              -
            </template>
            <template v-else-if="item.action === 'entered_storage'">
              Flasche steht voll im Lager.
            </template>
            <template v-else-if="item.action === 'at_customer'">
              Flasche wurde beim Kunden
              <template v-if="isAdmin">
                <!-- @formatter:off -->
							<router-link :to="'/admin/customers/'+item.customer_id"
										 class="text-primary">„{{item.customer.name}}”</router-link>
							<!-- @formatter:on -->
              </template>
              <template v-else>
                <span class="text-primary" @click="openCustomer(item.customer_id)">„{{ item.customer.name }}”</span>
              </template>
              abgestellt.
            </template>
            <template v-else-if="item.action === 'from_customer'">
              Flasche wurde vom
              <template v-if="isAdmin">
                <!-- @formatter:off -->

							<router-link :to="'/admin/users/'+item.driver_id"
										 class="text-primary">Fahrer
							</router-link>
							<!-- @formatter:on -->
              </template>
              <template v-else>
                Fahrer
              </template>
              abgeholt und befindet sich im Auto.
            </template>
            <template v-else-if="item.action === 'back_in_storage'">
              Flasche wurde aus dem Auto des Fahrers geladen und steht nun im Leergutlager.
            </template>
            <template v-else-if="item.action === 'left_storage'">
              Flasche wurde vom Großhändler abgeholt.
            </template>
          </div>
        </div>
      </template>
    </list>
  </div>
</template>

<script>
import List from "./List";
import timeFormatter from "../../mixins/timeFormatter";
import {mapMutations} from "vuex";

export default {
  name: "BottleActionLog",
  components: {List},
  mixins: [timeFormatter],
  props: {
    actions: Array,
  },
  computed: {
    isAdmin() {
      return !!this.$config.IS_ADMIN_PANEL
    },
    actionsReverse() {
      return this.actions.slice().reverse();
    }
  },
  methods: {
    ...mapMutations(['setSelectedCustomerId']),
    openCustomer(customer_id) {
      this.setSelectedCustomerId(customer_id);
      this.$router.push('/from_customer/customer/scanner').catch(() => null);
    }
  }
}
</script>

<style scoped>

</style>
